import styled from 'styled-components'
import { codGray, lightGray, white, neroGray } from 'tcp-common/lib/colors'
import Flex from 'tcp-common/lib/components/Flex'

export const MainWrapper = styled(Flex)`
background-color: ${neroGray};
justify-content:center;
align-items:center;
width:100%;
@media (min-width: 768px) {
    
    margin: 0 auto; 
}
`
export const MainContent = styled(Flex)`

width: 100%;
margin: 40px auto;
padding:0 16px;
max-width:1024px;
@media (max-width: 768px) {
    overflow-y: scroll;
    padding:24px 16px;
    margin:0px;
    max-width:90%;
}
`
export const CardsView = styled(Flex)`
`
export const Header = styled.h2`
font-weight: 600;
font-size: 36px;
line-height: 44px;
color: ${white};
text-align: center;
margin: 44px 0px 56px;
@media (max-width: 768px) {
    font-size: 24px;
    line-height: 32px;
    margin: 0;
}
`
export const SubHeader = styled.p`
font-weight: 400;
font-size: 16px;
line-height: 19px;
margin: 0 149px 16px;
color: ${lightGray};
@media (max-width: 768px) {
    font-size: 14px;
    line-height: 17px;
    margin: 0 16px 16px;
}
`
export const TermsButton = styled.button`
background: ${codGray};
height: 40px;
border: none;
text-align: center;
font-size: 14px;
line-height: 17px;
color: ${white};
cursor: pointer;
outline: none;
width: 100%;
&:focus {
  outline: none;
}
margin-top: 16px;
margin-bottom: 17px;
position: relative;
text-decoration: underline;
`
export const CloseModal = styled.img`
  position: sticky;
  right: 30px;
  float: right;
  cursor: pointer;
  @media (min-width: 768px) {
    top: 38px;
  }
  @media (max-width: 768px) {
    right: 16px;
  }
`
export const WrapperDiv = styled.div`
  height: auto;
  padding: 0 0 24px;
  position: relative;
`
export const SubHeaderView = styled.div``
export const ButtonText = styled.span`
margin-right: 8px;
color: ${white};
`
export const InterestedButton = styled.button`
background: #8241FF;
border-radius: 20px;
height: 40px;
border: none;
text-align: center;
font-size: 16px;
line-height: 24px;
color: ${white};
cursor: pointer;
outline: none;
&:focus {
  outline: none;
}
margin: auto 60px;
margin-top: 32px;
margin-bottom: 25px;
position: relative;
@media screen and (min-width: 768px) {
    max-width: 276px;
    display: block;
    margin-top: 56px;
    width: 100%;
    align-self: center;
    margin-bottom: 56px;
}
`
export const CardWrapper=styled.div`
max-width: 1024px;
    display: grid;
    grid-template-columns: auto auto;
    column-gap: 40px;
   
    `